import { assignChecks } from "./menuOptions";
import type {
	IData,
	IDataHash,
	IParsedTask,
	IHistory,
	IDataConfig,
} from "../types";
import type { TID } from "@svar-ui/lib-state";

const groupedToolbarButtons = new Set<TID>([
	"add-task",
	"delete-task",
	"edit-task",
	"undo",
	"redo",
]);

export function getToolbarButtons(config?: IDataConfig & { group?: boolean }) {
	let buttons = [...defaultToolbarButtons];

	// #if [!(WX_PACKAGE_TYPE=open)]
	if (config?.undo) {
		buttons = buttons.concat([
			{ comp: "separator" },
			{
				id: "undo",
				comp: "icon",
				icon: "wxi-undo",
				menuText: "Undo",
			},
			{
				id: "redo",
				comp: "icon",
				icon: "wxi-redo",
				menuText: "Redo",
			},
		]);
	}
	if (config?.splitTasks) {
		buttons.splice(2, 0, {
			id: "split-task",
			comp: "icon",
			icon: "wxi-arrow-split",
			menuText: "Split",
		});
	}

	if (config?.group)
		buttons = buttons.filter(
			b => b.comp === "separator" || groupedToolbarButtons.has(b.id)
		);

	if (buttons.length > defaultToolbarButtons.length || config?.group)
		buttons = assignChecks(buttons);
	// #endif
	return buttons;
}

export interface IButtonConfig {
	id?: string;
	comp: string;
	text?: string;
	icon?: string;
	type?: string;
	menuText?: string;
	isDisabled?:
		| ((
				task: IParsedTask,
				state: IData,
				target?: TID | IDataHash
		  ) => boolean)
		| ((history: IHistory) => boolean);
	isHidden?: (
		task: IParsedTask,
		state: IData,
		target?: TID | IDataHash
	) => boolean;
}

export const defaultToolbarButtons: IButtonConfig[] =
	assignChecks<IButtonConfig>([
		{
			id: "add-task",
			comp: "button",
			icon: "wxi-plus",
			text: "New task",
			type: "primary",
		},
		{
			id: "edit-task",
			comp: "icon",
			icon: "wxi-edit",
			menuText: "Edit",
			text: "Ctrl+E",
		},
		{
			id: "delete-task",
			comp: "icon",
			icon: "wxi-delete",
			menuText: "Delete",
			text: "Ctrl+D, Backspace",
		},
		{ comp: "separator" },
		{
			id: "move-task:up",
			comp: "icon",
			icon: "wxi-angle-up",
			menuText: "Move up",
		},
		{
			id: "move-task:down",
			comp: "icon",
			icon: "wxi-angle-down",
			menuText: "Move down",
		},
		{ comp: "separator" },
		{
			id: "copy-task",
			comp: "icon",
			icon: "wxi-content-copy",
			menuText: "Copy",
			text: "Ctrl+V",
		},
		{
			id: "cut-task",
			comp: "icon",
			icon: "wxi-content-cut",
			menuText: "Cut",
			text: "Ctrl+X",
		},
		{
			id: "paste-task",
			comp: "icon",
			icon: "wxi-content-paste",
			menuText: "Paste",
			text: "Ctrl+V",
		},
		{ comp: "separator" },
		{
			id: "indent-task:add",
			comp: "icon",
			icon: "wxi-indent",
			menuText: "Indent",
		},
		{
			id: "indent-task:remove",
			comp: "icon",
			icon: "wxi-unindent",
			menuText: "Outdent",
		},
	]);
